import Input from './ant';

export default Input;
